@if (activeTab === 'designation') {
  <table id="designationsSectionTable" class="table table-responsive" aria-describedby="Signing Agent Designations">
    <thead>
      <tr>
        <th scope="col" class="name-table-header sortable" style="width: 12vw" (click)="sortDesignationAccounts('firstName')">
          First Name
          @if (sortProperty === 'firstName') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header sortable" style="width: 12vw" (click)="sortDesignationAccounts('lastName')">
          Last Name
          @if (sortProperty === 'lastName') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header sortable" style="width: 26vw" (click)="sortDesignationAccounts('email')">
          Email Address
          @if (sortProperty === 'email') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header sortable" style="width: 35vw" (click)="sortDesignationAccounts('designationCode')">
          Designation
          @if (sortProperty === 'designationCode') {
            <span>
              @if (!sortAscending) {
                <span class="fas fa-arrow-down"></span>
              }
              @if (sortAscending) {
                <span class="fas fa-arrow-up"></span>
              }
            </span>
          }
        </th>
        <th scope="col" class="name-table-header" style="width: 15vw">
          Actions
        </th>
      </tr>
    </thead>
    <tbody>
      @for (designationAccount of userList; track designationAccount.accountId) {
        <tr>
          <td [title]="designationAccount.firstName">{{ designationAccount.firstName }}</td>
          <td [title]="designationAccount.lastName">{{ designationAccount.lastName }}</td>
          <td [title]="designationAccount.email">{{ designationAccount.email }}</td>
          <td>
            <mat-form-field class="clrsgn-form-field">
              <mat-select #designationSelect
                placeholder="Designation"
                [value]="getSelectedDesignation(designationAccount)"
                [title]="getDesignationDisplayValue(designationAccount)"
                (selectionChange)="setDesignation(designationAccount, $event.value, designationSelect)">
                @for (designation of designations; track designation.key) {
                  <mat-option [value]="designation.key">
                    {{ designation.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
          <td>
            <button
              type="button"
              class="btn-secondary d-flex align-items-center gap-1"
              (click)="deleteConfirmationDialog(designationAccount)">
              <i class="fas fa-trash-alt action-icon cursor-hand"></i>
              Delete
            </button>
          </td>
        </tr>
      }
      @empty {
        <tr>
          <td colspan="5" class="text-center py-4">
            @if (loadFailed) {
              Unable to load signing agent designations. Please refresh the page to try again.
            } @else {
              No signing agent designations found. Use the 'Add Designation' button to give a signing agent a designation.
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
